/**
 * 判断值是否为 Date
 * @return 是否为 Date
 */
export default function isDate(value) {
    return value instanceof Date;
}
//# sourceMappingURL=is-date.js.map